/* eslint react/no-array-index-key: 1 */

import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
// Components
import { Grid, Menu, IconButton } from '@material-ui/core';
import FilterIcon from '@material-ui/icons/FilterList';

import TableFilterDropDown from './TableFilterDropDown';
import TableFiltersMultiSelect from './TableFiltersMultiSelect';
import TableFilterDate from './TableFilterDate';
import TableFilterSearch from './TableFilterSearch';

const styles = (theme) => ({
    filterIcon: {
        position: 'absolute',
        top: -10,
        right: 0,
        'z-index': 10,
    },
    filtersPaper: {
        padding: 30,
        width: 290,
    },
    filters: {
        marginBottom: 10,
    },
});

const TableFilters = ({ filters, classes, intl }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeFilters, setActiveFilters] = useState({
        search: {
            global: '',
        },
        date: {},
        dropdown: {},
        multiselect: {},
    });

    const handleFilterChange = (type, fieldName, value) =>
        console.log(type, 'type', fieldName, 'fieldName', value, 'value');

    return (
        <Grid>
            <IconButton
                aria-label="More"
                aria-owns={anchorEl ? 'long-menu' : undefined}
                aria-haspopup="true"
                onClick={(e) => setAnchorEl(e.currentTarget)}
                className={classes.filterIcon}
            >
                <FilterIcon />
            </IconButton>

            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
            >
                <Grid className={classes.filtersPaper}>
                    {filters.map((filter, index) => {
                        switch (filter.type.toLowerCase(filter)) {
                            case 'dropdown':
                                return (
                                    <TableFilterDropDown
                                        onChange={handleFilterChange}
                                        key={`${filter.fieldName} ${index}`}
                                        filter={filter}
                                        activeFilters={activeFilters.dropdown}
                                        className={classes.filters}
                                    />
                                );
                            case 'multiselect':
                                return (
                                    <TableFiltersMultiSelect
                                        onChange={handleFilterChange}
                                        key={`${filter.fieldName} ${index}`}
                                        filter={filter}
                                        activeFilters={activeFilters.multiselect}
                                        className={classes.filters}
                                    />
                                );
                            case 'search':
                                return (
                                    <TableFilterSearch
                                        key={`${filter.fieldName} ${index}`}
                                        onChange={handleFilterChange}
                                        filter={filter}
                                        intl={intl}
                                        activeFilters={activeFilters.search}
                                        className={classes.filters}
                                    />
                                );
                            case 'date':
                                return (
                                    <TableFilterDate
                                        key={`${filter.fieldName} ${index}`}
                                        onChange={handleFilterChange}
                                        filter={filter}
                                        intl={intl}
                                        activeFilters={activeFilters.date}
                                        className={classes.filters}
                                    />
                                );
                            default:
                                return null;
                        }
                    })}
                </Grid>
            </Menu>
        </Grid>
    );
};

export default withStyles(styles)(TableFilters);
